import { PrescriptionAssistantModal } from '@/shared-ui/PrescriptionAssistantModal/PrescriptionAssistantModal';
import { useAppStore } from '@/state-management';
import { List, ListItem, Typography, useTheme } from '@mui/material';
import type { CancelMedicationItemType } from './../PrescriptionPad/';

export type CancelPrescribedMedicationModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
};

export const CancelPrescribedMedicationModal = ({
  isOpen,
  onClose,
  onConfirm,
  isLoading = false,
}: CancelPrescribedMedicationModalProps) => {
  const {
    prescriptionHistory: { itemsToCancel },
  } = useAppStore.use.prescriptionAssistant();

  const theme = useTheme();

  if (itemsToCancel.length < 1) {
    return null;
  }

  return (
    <PrescriptionAssistantModal
      open={isOpen}
      title="Cancel Prescription"
      severity="warning"
      isLoading={isLoading}
      loadingTitle="Cancelling prescription..."
      loadingBody="Please wait, this may take a moment."
      body={
        <>
          <Typography variant="body1" sx={{ color: theme.palette.text.primary, mb: theme.spacing(3) }}>
            Are you sure you want to cancel {itemsToCancel.length === 1 ? 'this prescription' : 'these prescriptions'}?
          </Typography>

          <List>
            {itemsToCancel.map(({ productId, displayName }: CancelMedicationItemType) => (
              <ListItem
                key={productId}
                sx={{
                  p: 0,
                  ml: theme.spacing(4),
                  fontWeight: 700,
                  color: theme.palette.text.primary,
                  display: 'list-item',
                  listStyleType: 'disc',
                }}
              >
                {displayName}
              </ListItem>
            ))}
          </List>
        </>
      }
      confirmLabel="Cancel Prescription"
      closeLabel="Not now"
      onConfirm={onConfirm}
      onClose={onClose}
    />
  );
};
